import '../pages/package/home/index';


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/entries/homepage.js